import { render, staticRenderFns } from "./menuItemWithSubmenu.vue?vue&type=template&id=969de81c&scoped=true&"
import script from "./menuItemWithSubmenu.vue?vue&type=script&lang=js&"
export * from "./menuItemWithSubmenu.vue?vue&type=script&lang=js&"
import style0 from "./menuItemWithSubmenu.vue?vue&type=style&index=0&id=969de81c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969de81c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('969de81c')) {
      api.createRecord('969de81c', component.options)
    } else {
      api.reload('969de81c', component.options)
    }
    module.hot.accept("./menuItemWithSubmenu.vue?vue&type=template&id=969de81c&scoped=true&", function () {
      api.rerender('969de81c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/contextMenu/menuItemWithSubmenu.vue"
export default component.exports